import { styled, Typography } from "@mui/material";

export const FieldLabel = styled(Typography)({
    color: 'rgb(90, 103, 125)',
    fontFamily: 'Rubik',
    fontSize: '16px',
    fontWeight: 400
})